(() => {
  function initialize(scope) {
    const sections = Array.from(scope.querySelectorAll('.nw-blog-article'));
    if (scope.matches?.('.nw-blog-article')) sections.unshift(scope);
    sections.forEach((section) => {
      if (section.dataset.editorialReady) return;
      section.dataset.editorialReady = 'true';
      const root = section.querySelector('[data-nwgem]');
      const input = root?.querySelector('[data-gem-search]');
      const select = root?.querySelector('[data-gem-category]');
      const clear = root?.querySelector('[data-gem-clear]');
      const cards = Array.from(root?.querySelectorAll('[data-gem-card]') || []);
      const status = root?.querySelector('[data-gem-status]');
      const empty = root?.querySelector('[data-gem-empty]');
      const normalize = (value) => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim();
      const filter = () => {
        const words = normalize(input?.value || '').split(/\s+/).filter(Boolean);
        const category = select?.value || '';
        let count = 0;
        cards.forEach((card) => {
          const text = normalize(card.dataset.search || card.textContent);
          const match = (!category || card.dataset.category === category) && words.every((word) => text.includes(word));
          card.hidden = !match;
          if (match) count += 1;
        });
        if (status) status.textContent = section.dataset.gemStatusTemplate.replace('[count]', count).replace('[total]', cards.length);
        if (empty) empty.hidden = count !== 0;
      };
      const reset = () => {
        if (input) input.value = '';
        if (select) select.value = '';
        filter();
      };
      input?.addEventListener('input', filter);
      select?.addEventListener('change', filter);
      clear?.addEventListener('click', () => {
        reset();
        input?.focus();
      });
      section.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || !section.contains(link) || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        if (link.closest('.nwpiercing.nw-placement-editorial')) return;
        const fragment = link.getAttribute('href').slice(1);
        if (!fragment) return;
        let id;
        try { id = decodeURIComponent(fragment); } catch { return; }
        const target = document.getElementById(id);
        if (!target || !section.contains(target)) return;
        event.preventDefault();
        if (cards.length) reset();
        const focusable = target.matches('a[href],button,input,select,textarea,summary,[tabindex]');
        if (!focusable) target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
        target.scrollIntoView({behavior: 'auto', block: 'start'});
      });
      if (root) root.dataset.gemReady = 'true';
      if (cards.length) {
        filter();
        window.addEventListener('pageshow', filter);
      }
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

